import React, { useState, useEffect } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { vendorDeptHeaderTyps } from '../../utils/vendorStaticData';
import VendorDeptStateRows from './VendorDeptStateRows';





const useStyles = makeStyles({
    table: {
        "& .MuiTableCell-root": {
            border: "1px solid rgba(224, 224, 224, 1)",
            align: 'center'
        }
    }
});



const VendorDeptStateTable = ({ headerRows, data, tableRef, selectedYear }) => {
    const classes = useStyles();
    const [tableWidth, setTableWidth] = useState(520);

    useEffect(() => {
        if (headerRows.length > 0) {
            const rowsWidth = (headerRows.length * 520) + 420;
            const colSpan = (headerRows.length * 4) + 2;
            setTableWidth(rowsWidth);
        }
    }, [headerRows])


    if (!headerRows || !data) {
        return null;
    }



    return (
        // <Paper sx={{ width: '96vw', overflow: 'hidden', my: 1 }}>
        //     <TableContainer sx={{ overflowX: 'auto', maxHeight: 'calc(100vh - 250px)' }} >
        //         <Table size="small" ref={tableRef} className={classes.table} aria-label="headquarter statics" sx={{ minWidth: tableWidth }}>
        <Paper sx={{ overflow: 'auto', my: 1 }}>
            <TableContainer sx={{ width: "100%", display: "table", tableLayout: "fixed" }} >
                <Table size="small" className={classes.table} ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" rowSpan={2}>매출처</TableCell>
                            <TableCell align="center" rowSpan={2}>고객사</TableCell>
                            {headerRows.map((header) => (
                                <TableCell colSpan={4} align="center" key={header.val}>
                                    {selectedYear}년 {header.name}
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            {headerRows.map((header) => {
                                return vendorDeptHeaderTyps.map((typ, index) => (
                                    <TableCell align="center" key={index}>{typ.name}</TableCell>
                                ))
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(data) && data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={14} align="center">데이터가 없습니다.</TableCell>
                            </TableRow>
                        ) : (
                            <VendorDeptStateRows headerRows={headerRows} data={data} />
                        )}

                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default VendorDeptStateTable